import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid gap-8 items-center md:grid-cols-2">
          <div>
            <span className="text-sm font-semibold text-orange-500 uppercase tracking-wider">
              WHO WE ARE
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mt-2">
              WHY CHOOSE RAULFEX?
            </h2>
          </div>
          <div className="space-y-6">
            <p className="text-lg text-gray-500">
              At Raulfex (Pty) Ltd, we specialize in property rentals. From
              family homes and apartments to business offices and warehouses,
              our mission is to provide flexible rental solutions backed by
              professional management and reliable support.
            </p>
            <button className="px-6 py-3 rounded-full border-2 border-gray-900 text-gray-900 font-semibold hover:bg-gray-900 hover:text-white transition-all duration-300">
              <Link to="/about">
               Learn More
              </Link>
             
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
